import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL, API_ROUTE_MAP } from '../config';
import { store } from '../app/store';

/**
 * 创建针对特定 URL 前缀的 axios 实例，
 * 自动从 Redux store 读取 token 注入 Authorization 头，
 * 通过 API_ROUTE_MAP 决定该前缀走哪个 backend（V1 或 V2）
 */
export function createApiClient(prefix: string): AxiosInstance {
  const curStore = store.getState();
  const token = curStore?.auth?.token;

  const base = API_ROUTE_MAP[prefix] || API_BASE_URL;

  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return axios.create({
    baseURL: `${base}${prefix}`,
    headers,
  });
}
